import TablesList from "./tables/TablesList"

const ListTables = () => {
    return (
        <>
            <TablesList />
        </>
    )
}

export default ListTables